module.exports = __webpack_public_path__ + "static/media/Youtube-QRCode.4de973fc.png";